o2-form-field {
  display: block;
  position: relative;
}

.help {
  display: flex;
  align-items: flex-start;
  position: relative;

  &.help--selectable {
    display: flex;
  }

  &--disabled {
    opacity: 0.4;
  }

  &--readonly {
    opacity: 0.4;
  }

  &--hidden {
    display: none;
  }
}

.help__text {
  font-size: 1.2rem;
  @include font-weight(400);
  line-height: 1.8rem;
  letter-spacing: 0.02rem;
  color: var(--o2-secondary, #{$text-main-secondary});

  display: -moz-box;
  display: -webkit-box;
  display: box;
  -moz-box-orient: vertical;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  overflow: hidden;
  line-clamp: 2;
  -webkit-line-clamp: 2;

  &.help__text--error {
    color: var(--o2-red, #{$red});

    .help-text--required.d-block ~ .help-text--pattern {
      display: none !important;
    }
  }

  &.help__text--warning {
    color: var(--o2-orange, #{$orange});
  }
}

.help-text {
  padding-top: $spacing-2;
  display: inline-block;

  &:not(.help-text--default) {
    display: none;
    padding: 0;

    &.d-block {
      padding-top: $spacing-2;
    }
  }
}

// TODO: ask why, it hides error help section for error state
o2-form-field o2-checkbox ~ .help,
o2-form-field o2-radio-group ~ .help {
  display: none;
}

// todo: check if still relevant
@media screen and (max-width: 768px) {
  o2-select[native='true'] ~ .help {
    position: relative;
    top: 20px;
  }
}
